
export default {
  name: 'mDatePicker',
  data() {
    return {
      panelShow: false,
      seleDate: new Date(),
      seleYear: new Date().getFullYear(),
      seleMonth: new Date().getMonth(),
      currDate: new Date(),
      currYear: new Date().getFullYear(),
      currMonth: new Date().getMonth(),
      monthNames: ["Jan", 
                   "Feb", 
                   "Mar", 
                   "Apr", 
                   "May", 
                   "June", 
                   "July", 
                   "Aug", 
                   "Sept", 
                   "Oct", 
                   "Nov", 
                   "Dec"],
      // monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    }
  },
  props: {
    multi: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Array | String | Date,
      default: []
    },
    lang: {
      type: String,
      default: 'en'
    },
    format: {
      type: Function,
      default: date => date.toLocaleDateString()
    },
    alwaysDisplay: {
      type: Boolean,
      default: false
    },
    disp: {
      type: Array,
      default: function () {
        if (this.lang === 'en') {
          return ['Sun', 'M', 'T', 'W', 'Th', 'F', 'Sat', 'Year', 'Month', 'Cancel', 'OK', 'Clear']
        } else {
          return ['日', '一', '二', '三', '四', '五', '六', '年', '月', '取消', '确定', 'Clear']
        }
      }
    },
  },
  mounted() {
    // console.log(this.value)
    // console.log(this.selected)
    // console.log(this.seleMonth)
  },
  computed: {
    renderCalendar: function () {
      // console.log("Render calendar")
      let firDay = 0 - (new Date(this.seleYear, this.seleMonth, 1).getDay()) + 1
      let res = []
      for (let i = firDay, index = 0; index < 42; i++, index++) {
        let day = new Date(this.seleYear, this.seleMonth, i, 0)
        let calObj = {
          label: day.getDate(),
          date: day,
          iscur: day.getMonth() === this.seleMonth
        }
        res.push(calObj)
      }
      // console.log(res)
      // console.log(firDay)
      return res
    },
    selected: function () {
      return this.value
    },
    display: function () {
      // console.log("in display")
      let d = this.disp
      if (!!!d) {
        if (this.lang === 'en') {
          d = ['Sun', 'M', 'T', 'W', 'Th', 'F', 'Sat', 'Year', 'Month', 'Cancel', 'OK']
        } else {
          d = ['日', '一', '二', '三', '四', '五', '六', '年', '月', '取消', '确定']
        }
      }
      return {
        days: d.slice(0, 7),
        year: d[7],
        month: d[8],
        cancel: d[9],
        ok: d[10],
        clear: d[11]
      }
    }
  },
  methods: {
    clickSelectedDate() {
      console.log("in click select date ")
      console.log(this.selected)
      this.panelShow = !this.panelShow
      if (this.selected != null) {
        if (Array.isArray(this.selected) == true && this.selected.length > 0) {
          this.seleMonth = this.selected[0].getMonth()
          this.seleYear = this.selected[0].getFullYear()
        }
        if (Array.isArray(this.selected) == false) {
          // console.log(this.selected.getMonth())
          // console.log(new Date(this.selected))
          this.seleMonth = this.selected.getMonth()
          this.seleYear = this.selected.getFullYear()
        }
      }
    },
    selectIndex: function (item) {
      // console.log("---------------")
      // console.log(item)
      // console.log(this.multi)
      // console.log(this.selected)

      // console.log(!this.multi && this.selected)
      if (!this.multi && this.selected) {
        // console.log("--gggg")
        if (this.selected.getTime() == item.date.getTime()) {
          return 0
        }
      }
      if (!this.multi || !this.selected) {
        return -1
      }
      // console.log("before loop")
      for (let i = 0; i < this.selected.length; i++) {
        // console.log("in loop ", this.selected[i].getTime(), item.date.getTime(), this.selected[i].getTime() == item.date.getTime())
        if (this.selected[i].getTime() == item.date.getTime()) {
          return i
        }
      }
      return -1
    },
    cancelSelect: function () {
      if (this.multi) {
        this.selected.splice(0, this.selected.length)
      } else {
        this.selected = null
      }
      this.panelShow = false
    },
    toggleSelect: function (item) {
      // console.log(item)
      if (!this.multi) {
        this.submitSelect(item.date)
      } else {
        let index = this.selectIndex(item)
        if (index < 0) {
          this.selected.push(item.date)
        } else {
          // console.log(this.selected)
          this.selected.splice(index, 1)
          // console.log(this.selected)
        }
      }
    },
    submitSelect: function (value) {
      this.$emit('input', value)
      this.panelShow = false
    },
    changeMonth(num) {
      console.log("change month ",this.seleMonth+num)
      if (this.seleMonth + num > 11) {
        this.seleMonth = 0
        this.seleYear++
      } else if (this.seleMonth + num < 0) {
        this.seleMonth = 11
        this.seleYear--
      } else {
        this.seleMonth += num
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/multi-date-picker/multiDatePicker.js